// src\components\ui\shop\categoryList.js
// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

export const CategoryList = ({categories, selectedCategory, setSelectedCategory}) => {
  return (
    <CategoryListContainer>
      {categories.map((cat, index) => (
        <CategoryItem
          key={index}
          active={selectedCategory === index + 1}
          onClick={() => setSelectedCategory(index + 1)}
        >
          {cat}
        </CategoryItem>
      ))}
    </CategoryListContainer>
  );
};

const CategoryListContainer = styled.div`
  padding: 10px;
  max-width: 100%;
  display: flex;
  overflow-x: auto;
  padding: 5px;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

const CategoryItem = styled.button`
  margin-bottom: 10px;
  max-width: 160px;

  padding: 8px;
  cursor: pointer;
  color: ${({active}) => (active ? 'black' : 'inherit')};
  @media (max-width: 768px) {
    margin-bottom: 0;
    margin-right: 8px;
  }
  @media (max-width: 435px) {
    font-size: 9pt;
    max-width: 130px;
  }
  @media (max-width: 375px) {
    font-size: 8pt;
    max-width: 100px;
  }
`;
